<template>
  <div class="banking-tab relative-position">
    <div v-if="!isEmptyBankData" class="content">
      <div class="row q-col-gutter-sm items-center">
        <div v-if="!lockData" class="col-12 q-mb-md">
          <info text-color="text-negative" icon-name="info" message="Remove bank data if not required to proceed save">
            <template slot="bottom-actions">
              <q-btn color="negative" rounded unelevated @click="clearData">
                {{ $t('Common.Remove.Text') }}
              </q-btn>
            </template>
          </info>
        </div>
        <div class="col-12">
          <q-btn-group rounded unelevated>
            <q-btn
              v-for="(banking, index) in memberData.banking.payment_data.bank_data"
              :key="`banking-${index}`"
              class="no-scope-css"
              :label="banking.title"
              rounded
              unelevated
              :disable="lockData"
              :color="memberData.banking.payment_data.selected === banking.id ? 'action-button-success' : 'grey-5'"
              @click="setBankingType(banking.id)"
            ></q-btn>
          </q-btn-group>
        </div>
        <div
          v-for="(banking, index1) in memberData.banking.payment_data.bank_data"
          class="fields"
          :class="memberData.banking.payment_data.selected === banking.id ? 'col-md-6' : 'col-12'"
        >
          <q-card v-if="memberData.banking.payment_data.selected === banking.id" square class="fit no-box-shadow">
            <div class="row q-col-gutter-sm">
              <div v-if="banking.fields.length > 0" class="col-12">
                <div class="row q-col-gutter-md">
                  <div
                    v-for="(field, index2) in sortDynamicFields(banking.fields)"
                    :key="field.label"
                    class="dynamic-field"
                    :class="{
                      'col-6': field.share && field.share.pos,
                      'col-12': !field.share,
                    }"
                  >
                    <q-input
                      v-if="field.type === 'input'"
                      v-model.trim="
                        field.autofill !== undefined &&
                        memberData.banking.payment_data.bank_data[index1].fields[
                          setDynamicFieldIndex(memberData.banking.payment_data.bank_data[index1].fields, field.index)
                        ].value === '' &&
                        !isFieldInEditState(field.index)
                          ? getAutoFill(field.autofill, index1, field.index)
                          : memberData.banking.payment_data.bank_data[index1].fields[
                              setDynamicFieldIndex(
                                memberData.banking.payment_data.bank_data[index1].fields,
                                field.index
                              )
                            ].value
                      "
                      hide-bottom-space
                      dense
                      outlined
                      :label="typeof field.share !== 'undefined' && field.share.pos === 'C' ? '' : field.label"
                      :error="
                        field.required
                          ? validation.banking.payment_data.bank_data.$each[index1].fields.$each[
                              setDynamicFieldIndex(
                                memberData.banking.payment_data.bank_data[index1].fields,
                                field.index
                              )
                            ].value.$error
                          : false
                      "
                      class="text-capitalize"
                      :class="{ required: field.required || false }"
                      clearable
                      :type="field.input_type ? field.input_type : 'text'"
                      :readonly="
                        lockData ||
                          (field.readonly
                            ? field.readonly
                            : field.autofill !== undefined && !isFieldInEditState(field.index))
                      "
                      @input="
                        field.readonly ? setInheritFieldValue(index1, field.inherit_index, field.inherit_column) : '',
                          validation.banking.payment_data.bank_data.$each[index1].fields.$each[
                            setDynamicFieldIndex(memberData.banking.payment_data.bank_data[index1].fields, field.index)
                          ].value.$touch
                      "
                    />
                    <q-select
                      v-if="
                        field.type === 'select' || (field.type === 'custom-select' && field.type !== 'masters-select')
                      "
                      v-model="
                        memberData.banking.payment_data.bank_data[index1].fields[
                          setDynamicFieldIndex(memberData.banking.payment_data.bank_data[index1].fields, field.index)
                        ].value
                      "
                      :readonly="
                        lockData ||
                          ((field.key === 'countries' ||
                            setDynamicFieldKeyOptionsData(field.key, field.identifier, index1, index2).length < 1) &&
                            field.type !== 'custom-select')
                      "
                      :label="field.label || false"
                      :options="
                        field.options
                          ? field.options
                          : setDynamicFieldKeyOptionsData(field.key, field.identifier, index1, index2)
                      "
                      :class="{ required: field.required || false }"
                      :error="
                        field.required
                          ? validation.banking.payment_data.bank_data.$each[index1].fields.$each[
                              setDynamicFieldIndex(
                                memberData.banking.payment_data.bank_data[index1].fields,
                                field.index
                              )
                            ].value.$error
                          : false
                      "
                      @input="
                        field.trigger ? triggerInherit(index1, field.trigger, field.key, field.value) : '',
                          field.required
                            ? validation.banking.payment_data.bank_data.$each[index1].fields.$each[
                                setDynamicFieldIndex(
                                  memberData.banking.payment_data.bank_data[index1].fields,
                                  field.index
                                )
                              ].value.$touch
                            : false
                      "
                    ></q-select>
                    <q-select
                      v-if="field.type === 'masters-select'"
                      v-model="
                        memberData.banking.payment_data.bank_data[index1].fields[
                          setDynamicFieldIndex(memberData.banking.payment_data.bank_data[index1].fields, field.index)
                        ].value
                      "
                      :error="
                        field.required
                          ? validation.banking.payment_data.bank_data.$each[index1].fields.$each[
                              setDynamicFieldIndex(
                                memberData.banking.payment_data.bank_data[index1].fields,
                                field.index
                              )
                            ].value.$error
                          : false
                      "
                      :class="{ required: field.required || false }"
                      :label="field.label || false"
                      :readonly="lockData"
                      :options="field.options ? field.options : masterDataOptionsCreator(field.identifier)"
                      @input="
                        field.trigger ? triggerInherit(index1, field.trigger) : '',
                          validation.banking.payment_data.bank_data.$each[index1].fields.$each[
                            setDynamicFieldIndex(memberData.banking.payment_data.bank_data[index1].fields, field.index)
                          ].$touch
                      "
                    ></q-select>
                    <q-btn
                      v-if="!isNewUser && !lockData && field.autofill !== undefined && !field.readonly"
                      class="q-mt-xs"
                      color="primary"
                      rounded
                      unelevated
                      outline
                      :label="isFieldInEditState(field.index) ? 'Done' : 'Edit'"
                      @click="setEditAutoFill(field.index)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </q-card>
        </div>
      </div>
    </div>
    <div v-else class="empty relative-position">
      <div class="row justify-center">
        <div class="col-md-auto">
          <q-btn
            :disable="lockData || !getCountryID"
            icon="add"
            color="positive"
            label="Setup Bank"
            @click="addBank()"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { MasterDataTransformarMixin, ScopeConfigMixin } from 'src/application/global/mixins'
import trans from 'src/application/global/components/common/transition/transition'
import EmptyList from '../empty/emptyList'
import QSelect from '../quasar/q-select/QSelectCustom'
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'MemberBankInfo',
  components: {
    trans,
    EmptyList,
    QSelect,
  },
  mixins: [MasterDataTransformarMixin, ScopeConfigMixin],
  props: {
    memberData: {
      type: Object,
      required: true,
    },
    lockData: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      required: true,
    },
    isNewUser: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedAddress: '',
    selectedCountry: '',
    selectedCountryByIndex: [],
    editAutoFill: [],
    cachedIncomeTaxCountryID: null,
  }),
  watch: {
    memberData: {
      handler(to) {
        if (this.isNewUser && this.scopeEnableFeature('isIncomeTaxCountryFieldEnableBinding', 'general.feature')) {
          let incomeTaxCountryID = this.$helpers.getValue(to, 'details.income_tax_country_id')
          if (this.cachedIncomeTaxCountryID !== incomeTaxCountryID) {
            this.getBanks(incomeTaxCountryID)
          }

          this.cachedIncomeTaxCountryID = this.$helpers.getValue(this.memberData, 'details.income_tax_country_id')

          let selectedID = to.banking.payment_data.selected || 0
          let selectedIdIndex = to.banking.payment_data.bank_data.findIndex(x => x.id === selectedID)
          let fields = _.cloneDeep(
            this.$helpers.getValue(to, `banking.payment_data.bank_data[${selectedIdIndex}].fields`)
          )
          if (fields) {
            fields.forEach((x, index) => {
              if (x.autofill) {
                this.memberData.banking.payment_data.bank_data[selectedIdIndex].fields[index].value = this.getAutoFill(
                  x.autofill,
                  selectedIdIndex,
                  index,
                  true
                )
              }
            })
          }
        } else {
          this.getBanks()
        }
      },
      deep: true,
      immediate: true,
    },
    getBankCountry(to) {
      if (to) {
        this.getBanks()
      }
    },
  },
  computed: {
    ...mapState({
      countriesOptions: state => state.globalCMP.countriesOptions.data,
      masterOptions: state => state.globalCMP.masterData.data.list,
      dynamicContentData: state => state.globalCMP.dynamicContentData.data,
      statesOptions: state => state.globalCMP.statesOptions.data,
      citiesOptions: state => state.globalCMP.citiesOptions.data,
      banksOptions: state => state.globalCMP.banksOptions.data,
    }),
    isEmptyBankData() {
      return (
        this.memberData.banking.payment_data.length < 1 || this.memberData.banking.payment_data.bank_data.length < 1
      )
    },
    getBankCountry() {
      let selectedBankId = this.$helpers.getValue(this.memberData, 'banking.payment_data.selected')
      if (selectedBankId) {
        let bankData = this.memberData.banking.payment_data.bank_data.find(x => x.id === selectedBankId)
        if (bankData) {
          let bankCountry = bankData.fields.find(x => x.label === 'Bank Country')
          if (bankCountry) {
            let bankCounty = this.countriesOptions.options.find(
              x => x.name.toLowerCase() === bankCountry.value.toLowerCase()
            )
            if (bankCounty) {
              return bankCounty.value
            }
          }
        }
      }
      return false
    },
    getCountryID() {
      if (this.scopeEnableFeature('isIncomeTaxCountryFieldEnableBinding', 'general.feature')) {
        return this.$helpers.getValue(this.memberData, 'details.income_tax_country_id')
      } else {
        return this.$helpers.getValue(this.memberData, 'details.country_id')
      }
    },
  },
  async mounted() {
    this.master.keys = ['bank_account_type']
  },
  methods: {
    ...mapActions([
      'getLanguagesAction',
      'getDynamicContentAction',
      'getStateAction',
      'getCitiesAction',
      'getCountriesBankAction',
    ]),
    addBank() {
      this.setPayoutTypesFields()
    },
    getBanks(countryId = false) {
      countryId = countryId || this.getBankCountry
      if (this.scopeEnableFeature('isIncomeTaxCountryFieldEnableBinding', 'general.feature')) {
        if (this.$helpers.isSet(this.memberData, 'details.income_tax_country_id', ['notEmpty', 'notNull'])) {
          countryId = this.$helpers.getValue(this.memberData, 'details.income_tax_country_id')
        }
      }
      if (countryId) {
        let query = {
          country_id: countryId,
          relations: ['banks'],
        }
        this.getCountriesBankAction(query)
      }
    },
    setBankingType(id) {
      this.memberData.banking.payment_data.selected = id
    },
    sortDynamicFields(fields) {
      return _.orderBy(fields, 'order', 'asc')
    },
    // Return back current index after sorting based on order to make sure inline with original array
    setDynamicFieldIndex(fields, index) {
      return fields.findIndex(x => x.index === index)
    },
    setDynamicFieldKeyOptionsData(key, identifier, index1, index2) {
      let name = key + 'Options'
      if (typeof this[name] !== 'undefined') {
        return this[name].options
      } else {
        return []
      }
    },
    setInheritFieldValue(index, triggerIndex, key, value) {
      let data = []
      let field = this.memberData.banking.payment_data.bank_data[index].fields.find(x => x.index === triggerIndex)
      if (Object.keys(field).length > 0) {
        data = this.setDynamicFieldKeyOptionsData(key).filter(x => x.value === value)
      }
      if (data.length > 0) {
        let triggeredFieldIndex = this.memberData.banking.payment_data.bank_data[index].fields.findIndex(
          x => x.index === triggerIndex
        )
        if (triggeredFieldIndex !== -1) {
          this.memberData.banking.payment_data.bank_data[index].fields[triggeredFieldIndex].value =
            data[0][field.inherit_column]
        }
      }
      return ''
    },
    triggerInherit(index, triggerIndex, key, value) {
      this.setInheritFieldValue(index, triggerIndex, key, value)
    },
    setPayoutTypesFields() {
      if (this.getCountryID && this.memberData.banking.payment_data.bank_data.length < 1) {
        let query = {
          country_id: this.getCountryID,
          types: ['member_payout_options'],
        }
        this.getDynamicContentAction(query).then(() => {
          if (
            typeof this.dynamicContentData !== 'undefined' &&
            this.dynamicContentData.member_payout_options.length > 0
          ) {
            this.memberData.banking.payment_data = JSON.parse(this.dynamicContentData.member_payout_options)
          }
        })
      }
    },
    getAutoFill(key, index, fieldIndex, valueOnly = false) {
      const value = key.split('.').reduce((a, b) => a[b], this.memberData)
      if (valueOnly) {
        return value
      }
      if (value !== '' || value !== null) {
        this.memberData.banking.payment_data.bank_data[index].fields[
          this.setDynamicFieldIndex(this.memberData.banking.payment_data.bank_data[index].fields, fieldIndex)
        ].value = value
      }
    },
    setEditAutoFill(index) {
      let editIndex = this.editAutoFill.findIndex(x => x === index)
      if (editIndex !== -1) {
        this.editAutoFill.splice(editIndex, 1)
      } else {
        this.editAutoFill.push(index)
      }
    },
    isFieldInEditState(index) {
      let editIndex = this.editAutoFill.findIndex(x => x === index)
      return editIndex !== -1
    },
    clearData() {
      let empty = {
        payment_data: {
          selected: '',
          bank_data: [],
        },
      }
      this.memberData.banking = Object.assign(this.memberData.banking, empty)
    },
  },
}
</script>
